import React from "react";
import "./PlansAndPricing.css";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from 'react-icons/fa';

const PlansAndPricing = () => {
  const navigate = useNavigate();
  
  const handleNavigateToContact = () => {
    navigate("/contact");
  };

  const plans = [
    {
      duration: "1 Year Plan",
      details: "Perfect for exploring business analytics on the go.",
      devices: "2 Devices",
      note: "1 Desktop App + 1 Mobile App",
      benefit: "Basic Onboarding",
    },
    {
      duration: "3 Year Plan",
      details: "Best value for small teams and growing businesses.",
      devices: "2 Devices",
      note: "1 Desktop App + 1 Mobile App",
      benefit: "Priority Support",
    },
    {
      duration: "5 Year Plan",
      details: "Maximum continuity for established enterprises.",
      devices: "2 Devices",
      note: "1 Desktop App + 1 Mobile App",
      benefit: "Dedicated Account Manager",
    },
  ];

  const features = [
    "All Premium Features",
    "Tally License Support",
    "Onboarding & Training",
    "Lifetime Product Support",
  ];

  return (
    <div className="pricing-container">
      <h1 className="pricing-title">Plans & Support</h1>
      
      <div className="plans-grid">
        {plans.map((plan, index) => (
          <div key={index} className="plan-card">
            <span className="plan-duration-badge">{plan.duration}</span>
            <h2>Business Edition</h2>
            
            <p className="plan-details-text">{plan.details}</p>
            
            <div className="device-info">
              <span className="device-count">{plan.devices} Included</span>
              <p className="device-note">{plan.note}</p>
            </div>
            
            <div className="plan-footer-notes">
              <p className="benefit-tag"><FaCheckCircle /> {plan.benefit}</p>
            </div>

            <button className="contact-plan-btn" onClick={handleNavigateToContact}>
              Contact for Pricing
            </button>
          </div>
        ))}
      </div>

      <div className="trial-button-container">
        <button className="trial-button" onClick={handleNavigateToContact}>
          Start Free 7 Day Trial
        </button>
      </div>

      <div className="features-section">
        <h3>Business Plan Includes</h3>
        <div className="features-list">
          {features.map((feature, index) => (
            <div key={index} className="feature-tag">
              <FaCheckCircle />
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlansAndPricing;
